import styled from 'styled-components';

export const ForgotPasswordCont = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  position: relative;
  justify-content: center;
  width: 656px;
`;
